import { interaction, XStack, XStackProps } from '@mythical/ui'

interface PaginationDotsProps {
  count: number
  activeIndex: number
  onChange: (index: number) => void
}

export const PaginationDots = (props: PaginationDotsProps & XStackProps) => {
  const { count, activeIndex, onChange, ...wrapperProps } = props
  return (
    <XStack justifyContent="center" flexWrap="wrap" {...wrapperProps}>
      {Array(count)
        .fill({})
        .map((_, i) => {
          const isActive = activeIndex === i
          return (
            <XStack
              tag="button"
              key={i}
              p="$1.5"
              onPress={() => onChange(i)}
              cursor="pointer"
              aria-label={`Go to slide ${i + 1}`}
              {...interaction.opacity}
            >
              <XStack
                w={8}
                h={8}
                borderRadius={1000}
                backgroundColor={isActive ? '$fgPrimary' : '$bgTertiary'}
                $gtSm={{
                  w: 11,
                  h: 11,
                }}
              />
            </XStack>
          )
        })}
    </XStack>
  )
}
